import React from 'react'
import { Trans } from '@lingui/macro'
import { showSelectedRangeOrCustom } from '../../utils/predefinedDateRanges'
import { ShowFilterModalButton } from '../../../pages/analytics/components/analytics-filter/ShowFilterModalButton'
import { ModalFilterEntitiesEnum } from '../entityFiltersModals'
import { useDateFilterContext } from '../dateFilter'

type PickDateFilterProps = {}

export const PickDateFilter: React.FC<PickDateFilterProps> = () => {
  const [filter] = useDateFilterContext()

  return (
    <ShowFilterModalButton
      modalId={ModalFilterEntitiesEnum.DATE}
      icon="pencil"
      persistent
    >
      <>
        <Trans>Date</Trans>:{' '}
        {showSelectedRangeOrCustom({
          period: filter.period,
          from: filter.from,
          to: filter.to
        })}
      </>
    </ShowFilterModalButton>
  )
}
